// @flow
import * as React from 'react';
import Container from './Container';
import NavigationBar from './NavigationBar';
import type { TNavigationState } from '../reducers/navigation';
import type { TVoidActionCreator, TNavigateToActionCreator } from '../reducers';

type TProps = {
  navigation: TNavigationState,
  navigateTo: TNavigateToActionCreator,
  navigateBack: TVoidActionCreator,
  showLogo?: boolean,
  showBack?: boolean,
  showExit?: boolean,
  children: React.Node,
  padded?: boolean,
};

export default function Layout(props: TProps): React.Node {
  const { children, ...rest } = props;
  return (
    <Container full fill="white" radius={8} zIndex={11111} overflow="hidden">
      <Container px={12}>
        <NavigationBar {...rest} />
      </Container>
      <Container px={props.padded ? 24 : 0} pt={props.padded ? 16 : 0}>{children}</Container>
    </Container>
  );
}
